"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceBoolean = enforceBoolean;
exports.enforceIterable = enforceIterable;
exports.enforcePositiveInt = enforcePositiveInt;
exports.enforceString = enforceString;
exports.enforceFunction = enforceFunction;
exports.enforceReactComponent = enforceReactComponent;
exports.createEnforceResolverValue = createEnforceResolverValue;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isNumber = _interopRequireDefault(require("transmute/isNumber"));

var _isObject = _interopRequireDefault(require("transmute/isObject"));

var _isString = _interopRequireDefault(require("transmute/isString"));

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _ResolverError = _interopRequireDefault(require("reference-resolvers/schema/ResolverError"));

var _ResolverLoading = _interopRequireDefault(require("reference-resolvers/schema/ResolverLoading"));

var _immutable = require("immutable");

function enforceBoolean(name, value) {
  (0, _invariant.default)(typeof value === 'boolean', 'expected `%s` to be a Boolean but got `%s`', name, value);
}

function enforceIterable(name, value) {
  (0, _invariant.default)(_immutable.Iterable.isIterable(value) || (0, _isObject.default)(value), 'expected `%s` to be an Immtuable Iterable or an Object but got `%s`', name, value);
}

function enforcePositiveInt(name, value) {
  (0, _invariant.default)((0, _isNumber.default)(value) && value >= 0, 'expected `%s` to be a positive integer but got `%s`', name, value);
}

function enforceString(name, value) {
  (0, _invariant.default)((0, _isString.default)(value), 'expected `%s` to be a string but got `%s`', name, value);
}

function enforceFunction(name, value) {
  (0, _invariant.default)((0, _isFunction.default)(value), 'expected `%s` to be a function but got `%s`', name, value);
}

function enforceReactComponent(name, value) {
  (0, _invariant.default)((0, _isFunction.default)(value), 'expected `%s` to be a react component but got `%s`', name, value);
}

function createEnforceResolverValue(name, checkValue) {
  return function (value) {
    (0, _invariant.default)(value == null || value instanceof _ResolverError.default || value instanceof _ResolverLoading.default || checkValue(value), 'expected value to be a %s, null, ResolverError or ResolverLoading, but got `%s`', name, value);
    return value;
  };
}